import React from "react";
import HomePage from "../structure/Home/HomePage";

export const Home = () => {
    return (
        <HomePage />
    )
}

export default Home;